// angular import
import { Component, Input, OnDestroy, OnInit } from '@angular/core';

// project import
import { ThemeLayoutService } from 'src/app/@theme/services/theme-layout.service';
import { HORIZONTAL, VERTICAL, COMPACT } from 'src/app/@theme/const';
import { AuthResourceService } from '@mri/app/resources';
import { Observable, Subscription, tap } from 'rxjs';
import { AuthCache, TitleType } from '@mri/types';
import { GlobalPageService } from '@mri/app/modules';

@Component({
  selector: 'app-nav-left',
  templateUrl: './toolbar-left.component.html',
  styleUrls: ['./toolbar-left.component.scss']
})
export class NavLeftComponent implements OnInit, OnDestroy {
  private _subscription = new Subscription();

  showToggleMenu: boolean = true;
  isShowFavicon = false;
  navigationList: Array<TitleType>;

  @Input() invertColor: boolean;

  get auth$(): Observable<AuthCache | undefined> {
    return this._authSrv.auth$;
  }

  // constructor
  constructor(
    private layoutService: ThemeLayoutService,
    private _authSrv: AuthResourceService,
    private _globalPageService: GlobalPageService,
  ) {
    this._subscription.add(
      this._globalPageService.breadcrumb$.subscribe((breadcrumb: Array<TitleType>) => {
        this.navigationList = breadcrumb;
      })
    );
  }

  ngOnInit() {
    this._subscription.add(
      this.layoutService.layout
        .pipe(
          tap((res) => {
            if (res === VERTICAL) {
              this.showToggleMenu = true;
            }
            if (res == HORIZONTAL) {
              this.showToggleMenu = false;
            }
            if (res === COMPACT) {
              this.showToggleMenu = true;
            }
          })
        )
        .subscribe()
    );

    this._subscription.add(
      this.layoutService.dashBoardMenuState
        .pipe(
          tap(value => console.log(value)),
          tap(value => this.isShowFavicon = !!value)
        )
        .subscribe()
    );

    this.isShowFavicon = !this.layoutService.drawerOpen;
  }

  ngOnDestroy() {
    this._subscription.unsubscribe();
  }

  // public method
  toggleMenu() {
    //this.layoutService.toggleSideDrawer();
    this.layoutService.toggleSideDrawer();

  }
}
